import * as React from 'react';
import { useLocation } from '@gatsbyjs/reach-router';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import facebookIcon from '@icons/facebookIcon';
import linkedinIcon from '@icons/linkedinIcon';
import twitterIcon from '@icons/twitterIcon';
import * as styles from './style.module.scss';
const {
  postFooter,
  postFooter__socials,
  postFooterSmall,
  postFooter__socialsSmall,
} = styles;

const PostFooter = ({ metaTitle, metaDescription, size = 'default' }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const currentUrl = location.href;
  const isSmall = size === 'small';

  const footerClassName = `${postFooter} ${isSmall ? postFooterSmall : ''}`;
  const socialsClassName = `${postFooter__socials} ${
    isSmall ? postFooter__socialsSmall : ''
  }`;

  const socials = [
    {
      title: 'Facebook',
      icon: facebookIcon,
      href: `https://www.facebook.com/sharer/sharer.php?u=${currentUrl}`,
    },
    {
      title: 'LinkedIn',
      icon: linkedinIcon,
      href: `http://www.linkedin.com/shareArticle?mini=true&url=${currentUrl}&title=${metaTitle}&summary=${metaDescription}`,
    },
    {
      title: 'Twitter',
      icon: twitterIcon,
      href: `https://twitter.com/intent/tweet?url=${currentUrl}text=${metaTitle}`,
    },
  ];

  return (
    <section className={footerClassName}>
      <p>{t('blog_post_share')}</p>
      <div className={socialsClassName}>
        {socials.map(({ title, icon, href }, index) => (
          <a
            key={`footer-${index}-link-${index}`}
            href={href}
            target="_blank"
            title={`Share on ${title}.`}
            rel="noreferrer"
          >
            {icon}
          </a>
        ))}
      </div>
    </section>
  );
};

export default PostFooter;

